Vue.component('v-banner', {
  data: function () {
    return {
      opened: false
    }
  },
  methods: {
    open: function () {
      this.opened = true
    },
    close: function () {
      this.opened = false
      setCookie('info_banner', Date.now(), {
        expires: 10000
      })
    }
  },
  mounted: function () {
    const daysCount = 3
    const ts = Vue.$cookies.get('info_banner')
    const diff = Date.now() - ts
    if (!ts || diff / (1000 * 60 * 60 * 24) > daysCount) this.open()
  }
})
